import{a as u}from"./chunk-RAAYCPUM.js";function s(...n){return u(l,n)}var l=(n,e)=>{let t=n.entries(),r=t.next();if(r.done??!1)return 0;let{value:[,i]}=r,a=e(i,0,n);for(let[o,m]of t){let b=e(m,o,n);a+=b}return a};export{s as a};
